import * as Immutable from "immutable";

const TaskMap = Immutable.OrderedMap;

export default TaskMap;
